import {
    Breakpoints,
    createA11yOutlineStyles,
    styled
} from '@volkswagen-onehub/components-core';
import {ChevronLeft, ChevronRight} from '@volkswagen-onehub/icons-core';
import {resetButtonStyles} from '../../helpers';

import {SLIDE_HEIGHT_MOBILE, SLIDE_HEIGHT_NON_MOBILE} from './SlideContent';

export const StyledTransitionWrapper = styled.div<{
    isMobileAndRtl: boolean;
}>`
    display: flex;
    touch-action: pan-y; // prevents page scrolling along with the user swipe actions
    ${({theme, isMobileAndRtl}) => {
        if (!isMobileAndRtl) {
            return 'flex-direction: row';
        }
        return theme.direction === 'rtl'
            ? 'flex-direction: row-reverse'
            : 'flex-direction: row';
    }}
`;

export const StyledPagination = styled.div`
    padding-bottom: ${props => props.theme.size.static250};
`;

export const StyledChevronLeft = styled(ChevronLeft)``;
export const StyledChevronRight = styled(ChevronRight)``;

export const StyledScrollButton = styled.button`
    ${resetButtonStyles}
    width: ${({theme}) => theme.size.static500};
    height: ${({theme}) => theme.size.static500};
    color: ${({theme}) => theme.colors.button.tertiary.default};
    background: ${({theme}) => theme.colors.background.primary};
    border-radius: 50%;
    opacity: 1;
    transition: ${({theme}) => {
        const duration = theme.animation.duration.layer;
        const timingFunction = theme.animation.timingFunction.in;
        return `opacity ${duration} ${timingFunction}`;
    }};
    display: flex;
    align-items: center;
    align-self: center;
    justify-content: center;

    :hover {
        // color: ${({theme}) => theme.colors.tab.hover};
        // NOTE: check with Design - by figma we should use this one, but tab.hover is aligned with focus & more visible
        color: ${({theme}) => theme.colors.button.tertiary.hover};
    }

    :focus-visible {
        ${({theme}) => createA11yOutlineStyles(theme, 'solid', true)};
    }

    ${StyledChevronLeft}, ${StyledChevronRight} {
        opacity: 1;
        transition: ${({theme}) => {
            const duration = theme.animation.duration.layer;
            const timingFunction = theme.animation.timingFunction.in;
            return `opacity ${duration} ${timingFunction}`;
        }};
        transition-delay: ${({theme}) => theme.animation.duration.layer};
    }

    :disabled {
        transition-delay: ${({theme}) => theme.animation.duration.layer};
        opacity: 0;
        cursor: auto;
        pointer-events: none;

        ${StyledChevronLeft}, ${StyledChevronRight} {
            opacity: 0;
            transition-delay: 0s;
        }
    }

    @media (max-width: ${Breakpoints.b560 - 1}px) {
        visibility: hidden;
    }
`;

export const StyledSliderUiWrapper = styled.div`
    min-height: ${SLIDE_HEIGHT_MOBILE};
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1;
    padding: 0 ${props => props.theme.size.grid001};
    pointer-events: none;

    display: grid;
    grid-template-columns: [blockstart-start] max-content [blockstart-end center-start] auto [center-end blockend-start] max-content [blockend-end];
    grid-template-rows: [row1-start] 1fr [row1-end row2-start] 1fr [row2-end row3-start] 1fr [row3-end];

    & ${StyledScrollButton}.previous {
        grid-column: blockstart;
        grid-row: row2;
    }

    & ${StyledScrollButton}.next {
        grid-column: blockend;
        grid-row: row2;
    }

    & ${StyledPagination} {
        grid-column: center;
        grid-row: row3;
        align-self: end;
    }

    & button {
        pointer-events: auto;
    }

    @media (min-width: ${Breakpoints.b560}px) {
        min-height: ${SLIDE_HEIGHT_NON_MOBILE};
    }
`;

export const StyledStageSlideContainer = styled.div`
    width: 100%;
    min-height: ${SLIDE_HEIGHT_MOBILE};
    isolation: isolate;
    margin: 0 auto;
    position: relative;

    @media (min-width: ${Breakpoints.b560}px) {
        min-height: ${SLIDE_HEIGHT_NON_MOBILE};
    }
`;

export const StyledSlideContainer = styled.div`
    position: absolute;
    height: 100%;
    inset: 0;
`;
